"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.passwordResetAccepted = exports.passwordResetStatus = exports.passwordResetConfirm = exports.passwordResetRequest = exports.mfaConfirmResponse = exports.mfaCodeRequest = exports.mfaEnrollResponse = exports.sessionResponse = exports.loginStatus = exports.rolePermissions = exports.permissionName = exports.sessionUserDto = exports.membershipDto = exports.loginRequest = exports.email = exports.password = void 0;
const zod_1 = require("zod");
const company_1 = require("./company");
const common_1 = require("./common");
/**
 * عقود المصادقة — مشتركة بين الـ API والواجهة.
 * كلمة السر لا تظهر فى أى نوع استجابة، ولا تُسجَّل، ولا تُعاد.
 */
/** الحد الأدنى ١٢ محرفًا: عبارة مرور أقوى من تعقيد قصير يصعب تذكره. */
exports.password = zod_1.z
    .string()
    .min(12, 'password must be at least 12 characters')
    .max(256, 'password must be at most 256 characters');
exports.email = zod_1.z.string().email().max(254).toLowerCase();
exports.loginRequest = zod_1.z
    .object({
    email: exports.email,
    password: zod_1.z.string().min(1).max(256),
})
    .strict();
/** عضوية المستخدم فى شركة — الدور خاصية (مستخدم، شركة) لا خاصية مستخدم. */
exports.membershipDto = zod_1.z.object({
    companyId: common_1.uuid,
    legalNameAr: zod_1.z.string(),
    role: company_1.roleName,
    /** الدور المخصص إن وُجد — صلاحياته هى الفاعلة بدل صلاحيات الدور. */
    customRoleName: zod_1.z.string().nullable(),
    /** الصلاحيات الفاعلة: الواجهة تُخفى بها ما سيُرفض، والـ API يفرضها على أى حال. */
    permissions: zod_1.z.array(zod_1.z.lazy(() => exports.permissionName)),
    /**
     * الشركة للقراءة فقط (موقوفة أو انتهت تجربتها): الواجهة تعرض تنبيهًا وتُخفى أزرار
     * الكتابة، والـ API يرفض الكتابة على أى حال.
     */
    readOnly: zod_1.z.boolean(),
});
exports.sessionUserDto = zod_1.z.object({
    id: common_1.uuid,
    email: zod_1.z.string().email(),
    displayName: zod_1.z.string(),
    tenantId: common_1.uuid,
    memberships: zod_1.z.array(exports.membershipDto),
    /** مشغّل منصة — `true` فقط حين تعمل الخدمة بـ PLATFORM_MODE، وإلا `false` دائمًا. */
    isPlatformAdmin: zod_1.z.boolean(),
    /** انتهاء الصلاحية المطلق للجلسة — الواجهة تعرض تحذيرًا قبله. */
    sessionExpiresAt: zod_1.z.string(),
    /**
     * الدخول بخطوتين: `enabled` عامل مؤكَّد مسجَّل، و`canDisable` خطأ لمشغّل المنصة
     * (مفروض عليه دائمًا). الواجهة تعرض زر الإيقاف أو التفعيل منه.
     */
    mfa: zod_1.z.object({ enabled: zod_1.z.boolean(), canDisable: zod_1.z.boolean() }),
});
exports.permissionName = zod_1.z.enum([
    'company.read',
    'report.read',
    'journal.post',
    'journal.manual',
    'period.close',
    'period.reopen',
    'user.manage',
    'settings.manage',
    'data.import',
]);
/**
 * مصفوفة الأدوار — مصدر واحد للـ API (الذى يفرضها) والواجهة (التى تُخفى ما
 * لن يُسمح به). الإخفاء فى الواجهة راحة لا حماية: الـ API يرفض على أى حال.
 *
 * `clerk` يرحّل مستندات التشغيل (فواتير، تحصيل) ولا يكتب قيدًا يدويًا —
 * القيد اليدوى عمل محاسب. و`viewer` لا يرحّل شيئًا أبدًا.
 *
 * `period.reopen` للمالك وحده (قرار المالك، 2026-10-19): إعادة الفتح تمس أرقامًا رآها
 * أحد بالفعل، وفصل المهام يقتضى ألا يعيد من أقفل الفتح بنفسه.
 *
 * `data.import` (مركز ترحيل البيانات) للمالك والمحاسب: الدفعة المعتمدة قيد بسطور من ملف
 * خارجى، فهى عمل محاسب كالقيد اليدوى لا عمل مُدخل.
 *
 * مرجع القرار: docs/adr/0004-authentication-and-sessions.md
 */
exports.rolePermissions = {
    owner: [
        'company.read',
        'report.read',
        'journal.post',
        'journal.manual',
        'period.close',
        'period.reopen',
        'user.manage',
        'settings.manage',
        'data.import',
    ],
    accountant: [
        'company.read',
        'report.read',
        'journal.post',
        'journal.manual',
        'period.close',
        'data.import',
    ],
    clerk: ['company.read', 'report.read', 'journal.post'],
    viewer: ['company.read', 'report.read'],
};
/**
 * حالة الدخول — الجلسة لا تكون كاملة بمجرد كلمة السر حين يُفرض عامل ثانٍ.
 *
 *  - `authenticated`: جلسة كاملة، لا شىء آخر مطلوب.
 *  - `mfa_required`: للمستخدم عامل مؤكَّد — جلسة جزئية لا تصلح إلا لمسار التحقق.
 *  - `mfa_enrollment_required`: MFA مفروضة عليه ولا عامل له — جلسة جزئية للتسجيل الإجبارى.
 */
exports.loginStatus = zod_1.z.enum(['authenticated', 'mfa_required', 'mfa_enrollment_required']);
exports.sessionResponse = zod_1.z.object({
    status: exports.loginStatus,
    /** انتهاء الصلاحية المطلق. الجلسة الجزئية عمرها دقائق لا ساعات. */
    expiresAt: zod_1.z.string(),
});
/**
 * بدء تسجيل عامل TOTP. السر يُعاد **مرة واحدة هنا فقط** — قبل التأكيد — ثم لا
 * يُعاد أبدًا، لا فى هذا المسار ولا فى غيره.
 */
exports.mfaEnrollResponse = zod_1.z.object({
    /** السر بترميز base32 لمن يُدخله يدويًا بدل مسح الرمز. */
    secret: zod_1.z.string(),
    /** otpauth:// — الواجهة ترسمه رمزًا مربعًا فى المتصفح، فلا صورة سر على الخادم. */
    otpauthUri: zod_1.z.string(),
});
/**
 * رمز تحقق: TOTP من ستة أرقام، أو كود استرداد.
 * الطول الأقصى يحمى من حمولة ضخمة تُستهلك فى المقارنة.
 */
exports.mfaCodeRequest = zod_1.z
    .object({
    code: zod_1.z.string().trim().min(6).max(32),
})
    .strict();
/** أكواد الاسترداد تُعرض **مرة واحدة** عند التأكيد، ولا تُقرأ من الخادم بعدها. */
exports.mfaConfirmResponse = zod_1.z.object({
    status: exports.loginStatus,
    expiresAt: zod_1.z.string(),
    recoveryCodes: zod_1.z.array(zod_1.z.string()),
});
/**
 * استعادة كلمة السر بالبريد — بلا جلسة.
 *
 * الطلب يُرد بنفس الاستجابة سواء وُجد البريد أو لم يوجد: لا تُبنى منه قائمة
 * حسابات. والرمز يصل فى رابط البريد وحده، ولا يُعاد فى أى استجابة.
 */
exports.passwordResetRequest = zod_1.z
    .object({
    email: exports.email,
})
    .strict();
/** الرمز ٣٢ بايت base64url = ٤٣ محرفًا؛ الحدود تمنع حمولة ضخمة قبل التجزئة. */
exports.passwordResetConfirm = zod_1.z
    .object({
    token: zod_1.z.string().trim().min(32).max(128),
    newPassword: exports.password,
})
    .strict();
/** هل الاستعادة بالبريد متاحة على هذه التسطيبة — الواجهة تُخفى الرابط حين لا بريد مضبوط. */
exports.passwordResetStatus = zod_1.z.object({
    enabled: zod_1.z.boolean(),
});
/** ردّ طلب الاستعادة — واحد دائمًا، وُجد البريد أو لم يوجد. */
exports.passwordResetAccepted = zod_1.z.object({
    status: zod_1.z.literal('accepted'),
});
//# sourceMappingURL=auth.js.map